// extracted by mini-css-extract-plugin
export var acceptButton = "_1q-5";
export var fullContent = "_1q-4";
export var link = "_1q-6";
export var linkIcon = "_1q-7";
export var sideContent = "_1q-3";
export var sideImage = "_1q-2";
export var sideImageWrapper = "_1q-1";
export var splitLayout = "_1q-0";